import React, { useEffect, useState } from 'react'
import { message, Pagination } from 'antd'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import clsx from 'clsx';
import Select from 'react-select'
import "./seoSetup.scss"
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers';
import { useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap-v5';
import httpService from '../../setup/http/httpServices';
import { number } from 'yup/lib/locale';



const seoSchema = Yup.object().shape({
    firstKeyword: Yup.string(),
    connector: Yup.string(),
    modifier: Yup.string(),
    secondKeyword: Yup.string(),
    secondConnector: Yup.string(),
    secondModifier: Yup.string(),
    description: Yup.string(),
});

const options = [
    { value: 'Website', label: 'Website Categories' },
    { value: 'Section', label: 'Section Categories' },
    { value: 'Framework', label: 'Framework Categories' }
]




const SEOSetup = () => {
    const [deleteId, setDeleteId] = useState('');
    const [show, setShow] = useState(false);
    const [urlIndex, setUrlIndex] = useState(0);
    const [totalCount, setTotalCount] = useState(0)
    const [listParams, setListParams] = useState({
        limit: 10,
        page: 1,
        total: totalCount || 0,
        search: '',
    })

    const [showUrls, setShowUrls] = useState(false);
    const [seoTemplates, setSeoTemplates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [update, setUpdate] = useState(false);
    const [id, setId] = useState()
    const history: any = useHistory();


    const initialValues = {
        firstKeyword: '',
        connector: '',
        modifier: '',
        secondKeyword: '',
        secondConnector: '',
        secondModifier: '',
        description: '',
    };


    const handleClose = () => setShow(false);
    const handleCloseUrlModel = () => setShowUrls(false);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: seoSchema,
        enableReinitialize: true,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setIsLoading(true);

            if (update) {
                httpService.patchData(
                    `/seo/update-template/${id}`,
                    {
                        firstKeyword: values.firstKeyword,
                        connector: values.connector,
                        modifier: values.modifier,
                        secondKeyword: values.secondKeyword,
                        secondConnector: values.secondConnector,
                        secondModifier: values.secondModifier,
                        description: values.description,
                    },
                    (res) => {
                        console.log(res);
                        setIsLoading(false)
                        formik.resetForm()
                        getAllTemplates();
                        setUpdate(false);

                    },
                    (err) => {
                        console.log(err);
                        message.error(err.message);
                        setIsLoading(false)


                    }
                )
            } else {
                httpService.postData(
                    '/seo/add-template',
                    {
                        firstKeyword: values.firstKeyword,
                        connector: values.connector,
                        modifier: values.modifier,
                        secondKeyword: values.secondKeyword,
                        secondConnector: values.secondConnector,
                        secondModifier: values.secondModifier,
                        description: values.description,
                    },
                    (res) => {
                        console.log("seo", res);

                        setUpdate(false);
                        setIsLoading(false);
                        formik.resetForm()
                        getAllTemplates();
                    },
                    (err) => {
                        console.log(err);
                        setUpdate(false);
                        message.error(err.message);
                        setIsLoading(false)


                    }
                )
            }


        }
    });

    const getSitemap = async () => {
        httpService.getData(
            '/sitemap.xml',
            (res) => {
                console.log("sitemap", res.data)
            },
            (err) => {
                console.log('err', err)
            }
        )
    }

    const getAllTemplates = async () => {
        httpService.getData(
            `/seo/all-template?page=${listParams.page}&limit=${listParams.limit}`,
            (res) => {
                const totalCount = res.data?.total || 0;

                // console.log("all template", res.data)
                getSitemap();
                setTotalCount(totalCount)
                setSeoTemplates(res.data?.seoTemplates);
                setListParams((prev) => ({ ...prev, total: totalCount }));
            },
            (err) => {
                message.error('Not able to fetch.')
            }
        )
    }



    useEffect(() => {
        getAllTemplates();
    }, [listParams.page, listParams.limit])


    const key = 'updatable'
    const handleDelete = (id: string) => {
        console.log('in hadledelete function')
        setShow(false)
        message?.loading({ content: 'Loading...', key })
        httpService.deleteData(
            '/seo/delete-template/' + deleteId,
            (res: any) => {
                setTimeout(() => {
                    message.success({ content: 'SEO Template deleted!', key, duration: 2 })
                    setDeleteId('')
                }, 1000)
                getAllTemplates();
            },
            (err: any) => {
                message?.error({ content: err.message, key, duration: 2 })
                setDeleteId('')
            }
        )
    }


    return (
        <div className='d-flex justify-content-center'>
            <div className="addCategory">
                <h3 className='mb-4'>Add New Website Type</h3>
                <form noValidate className='seo-form' onSubmit={formik.handleSubmit} >
                    <div>
                        <h6 className='fw-bold '>First Keyword</h6>
                        <input
                            {...formik.getFieldProps('firstKeyword')}
                            type='text'
                            className={clsx(
                                'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                                {
                                    'is-invalid': formik.touched.firstKeyword && formik.errors.firstKeyword,
                                },
                                {
                                    'is-valid': formik.touched.firstKeyword && !formik.errors.firstKeyword,
                                }
                            )}
                        />

                        {formik.touched.firstKeyword && formik.errors.firstKeyword && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span className='text-danger' role='alert'>
                                        {formik.errors.firstKeyword}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <h6 className='fw-bold'>Connector</h6>
                        <input
                            {...formik.getFieldProps('connector')}
                            type='text'
                            className={clsx(
                                'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                                {
                                    'is-invalid': formik.touched.connector && formik.errors.connector,
                                },
                                {
                                    'is-valid': formik.touched.connector && !formik.errors.connector,
                                }
                            )}
                        />

                        {formik.touched.connector && formik.errors.connector && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span className='text-danger' role='alert'>
                                        {formik.errors.connector}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <h6 className='fw-bold'>Modifier</h6>
                        <Select
                            options={options}
                            placeholder='Select Modifier'
                            className={clsx(
                                'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-1'
                            )}
                            onChange={(selectedOption) => {
                                formik.setFieldValue('modifier', selectedOption.value);
                            }}
                            onBlur={formik.handleBlur('modifier')}
                            value={options.find((option) => option.value === formik.values.modifier)}
                        />
                    </div>
                    <div>
                        <h6 className='fw-bold'>Second Keyword</h6>
                        <input
                            {...formik.getFieldProps('secondKeyword')}
                            type='text'
                            className={clsx(
                                'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                                {
                                    'is-invalid': formik.touched.secondKeyword && formik.errors.secondKeyword,
                                },
                                {
                                    'is-valid': formik.touched.secondKeyword && !formik.errors.secondKeyword,
                                }
                            )}
                        />

                        {formik.touched.secondKeyword && formik.errors.secondKeyword && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span className='text-danger' role='alert'>
                                        {formik.errors.secondKeyword}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <h6 className='fw-bold'>Connector</h6>
                        <input
                            {...formik.getFieldProps('secondConnector')}
                            type='text'
                            className={clsx(
                                'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                                {
                                    'is-invalid': formik.touched.secondConnector && formik.errors.secondConnector,
                                },
                                {
                                    'is-valid': formik.touched.secondConnector && !formik.errors.secondConnector,
                                }
                            )}
                        />

                        {formik.touched.secondConnector && formik.errors.secondConnector && (
                            <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                    <span className='text-danger' role='alert'>
                                        {formik.errors.secondConnector}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <h6 className='fw-bold'>Modifier</h6>
                        <Select
                            options={options}
                            placeholder='Select Modifier'
                            className={clsx(
                                'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-1'
                            )}
                            onChange={(selectedOption) => {
                                formik.setFieldValue('secondModifier', selectedOption.value);
                            }}
                            onBlur={formik.handleBlur('secondModifier')}
                            value={options.find((option) => option.value === formik.values.secondModifier)}
                        />
                    </div>
                    <div className='m16 w-100 flex flex-wrap'>

                        <button
                            type='submit'
                            disabled={!formik.isValid || isLoading}
                            className='btn btn-primary fs-6 categoryButton '
                        >
                            {update ? "Update" : "Add"}
                        </button>
                        <button
                            type='button'
                            onClick={() => {
                                formik.resetForm();
                                setUpdate(false);
                            }}
                            className='btn fw-bolder btn-white fs-6 categoryButton '
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>

            <div className='categoryTable' style={{ minHeight: '100px' }}>
                <div className='categoryTableHeader'>
                    <div className='mt-3 min-w-450px ps-5'>
                        <h3 style={{ cursor: 'default' }}>Roles</h3>
                    </div>
                </div>
                <div className='card-body mt-0 p-0 d-flex flex-column justify-content-between'>
                    <div className='table-responsive'>
                        <table className='table min-h-95 table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                                <tr className='fw-bolder text-muted'>
                                    <th className='bg-gray-100 ps-5 min-w-350px'>
                                        <span className='d-flex'>
                                            SEO Rule Name
                                        </span>
                                    </th>
                                    <th className='bg-gray-100 ps-5 min-w-200px'>
                                        <span className='d-flex'>
                                            Pages Generated
                                        </span>
                                    </th>
                                    <th className='bg-gray-100 ps-5 min-w-50px'>
                                        <span className='d-flex'>
                                            Actions
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    seoTemplates?.length !== 0 ?
                                        seoTemplates?.map((item: any, index: any) => (
                                            <tr key={index}>
                                                <td className=' d-flex justify-content-start'>
                                                    <div className='d-flex  flex-column ps-5 align-items-center'>
                                                        <span className='text-dark fw-bolder text-hover-primary fs-6'>
                                                            {`${item?.firstKeyword} ${item?.connector} ${item.modifier ? `[${item?.modifier} Category]` : ''}  ${item?.secondKeyword} ${item?.secondConnector} ${item.secondModifier ? `[${item?.secondModifier} Category]` : ''} `}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span
                                                        onClick={() => {
                                                            setShowUrls(true);
                                                            setUrlIndex(index);
                                                        }}
                                                        style={{ cursor: "pointer", textAlign: "center" }}
                                                    >{item.urls?.length}</span>
                                                </td>
                                                <td className='d-flex justify-content-end'>
                                                    <div className='d-flex justify-content-start flex-shrink-0'>
                                                        <span
                                                            className='svg-icon flex svg-icon-dark bg-primary bg-opacity-5 w-30px h-30px rounded me-2 pointer'
                                                            onClick={() => {
                                                                formik.setFieldValue("firstKeyword", item.firstKeyword, false);
                                                                formik.setFieldValue("connector", item.connector, false);
                                                                formik.setFieldValue("modifier", item.modifier, false);
                                                                formik.setFieldValue("secondKeyword", item.secondKeyword, false);
                                                                formik.setFieldValue("secondConnector", item.secondConnector, false);
                                                                formik.setFieldValue("secondModifier", item.secondModifier, false);
                                                                setUpdate(true);
                                                                setId(item?._id)

                                                            }}

                                                        >
                                                            <KTSVG
                                                                className='svg-icon-3'
                                                                path={toAbsoluteUrl('/media/icons/Custom/Pen.svg')}
                                                            />
                                                        </span>
                                                        <span
                                                            onClick={() => {
                                                                setShow(true);
                                                                setDeleteId(item?._id)

                                                            }}
                                                            className='svg-icon flex svg-icon-danger bg-danger bg-opacity-5 w-30px h-30px rounded pointer'
                                                        >
                                                            <KTSVG
                                                                className='svg-icon-3'
                                                                path={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                                                            />
                                                        </span>
                                                        <Modal
                                                            show={show}
                                                            onHide={handleClose}
                                                            aria-labelledby='contained-modal-title-vcenter'
                                                            centered
                                                        >
                                                            <Modal.Header>
                                                                <Modal.Title>Delete</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body>Are you sure you wanna delete?</Modal.Body>
                                                            <Modal.Footer>
                                                                <button
                                                                    className='btn fw-bolder btn-gray-200 fs-6 dialogButton'
                                                                    onClick={() => {
                                                                        setShow(false)
                                                                        setDeleteId('')
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                                <button
                                                                    className='btn btn-primary fs-6 dialogButton ms-2'
                                                                    onClick={() => handleDelete(deleteId)}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </Modal.Footer>
                                                        </Modal>


                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                        : (
                                            <tr>
                                                <td colSpan={7}>
                                                    <div className='m-20'>
                                                        <div className='flex'>
                                                            <img
                                                                src={toAbsoluteUrl('/media/logos/TableVector.png')}
                                                                style={{ width: "100%", height: "100%" }}
                                                            ></img>
                                                        </div>
                                                        <div className='flex'>
                                                            <div>
                                                                <h2 className='mb-0 m24 flex'>No Seo Listed</h2>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )

                                }

                            </tbody>
                        </table>
                    </div>
                </div>

                {totalCount > 10 && (
                    <div className='d-flex ms-5 me-10 justify-content-between align-items-end flex-wrap mb-10'>
                        <span className='text-muted pb-2'>
                            Page {listParams.page} of{' '}
                            {Math.floor(totalCount % listParams.limit) === 0
                                ? Math.floor(totalCount / listParams.limit)
                                : Math.floor(totalCount / listParams.limit) + 1}
                        </span>
                        <div className='d-flex flex-wrap '>
                            <Pagination
                                className=''
                                pageSize={listParams.limit}
                                defaultCurrent={listParams.page}
                                total={totalCount}
                                onChange={(e) => setListParams({ ...listParams, ...{ page: e } })}
                            />
                        </div>
                    </div>
                )}
            </div>
            <Modal
                show={showUrls}
                onHide={handleCloseUrlModel}
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <div className="urls-model-box">
                    <Modal.Header>
                        <Modal.Title>Rule Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="seo-urls">
                            {
                                seoTemplates[urlIndex]?.urls?.map((item: any, index: any) => (
                                    <p key={index} onClick={() => window.open(`${item}`, "_blank")}>{item}</p>
                                ))
                            }
                        </div>
                    </Modal.Body>
                </div>

            </Modal>

        </div>
    )
}

export default SEOSetup